module.exports = __webpack_public_path__ + "img/arrows-2-3.fda6bafb.svg";